// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__-Q2P7","item":"Contacts_item__iIaNI","left":"Contacts_left__ewns5","center":"Contacts_center__YWvme","right":"Contacts_right__msCBF"};